import { BusinessObjectBase } from './base';
import { registryTokenSchema } from '@schemas/business-objects/registry-token';
import type { LoginSession } from './login-session';
import type { NpmPackage } from './npm-package';
import type { User } from './user';
import type { Id } from '../base-types';

export interface RegistryTokenData {
  readonly id: Id;
  readonly name?: string;
  readonly tokenHash?: string;
  readonly tokenPrefix?: string;
  readonly canPublish?: boolean;
  readonly expiresAt?: Date;
  readonly lastUsedAt?: Date;
  readonly revokedAt?: Date;
  readonly publishedFromRepository?: string;
  readonly publishedFromWorkflow?: string;
  readonly publishedFromRunId?: string;
  readonly actor?: string;
  readonly userId: Id;
  readonly user?: User;
  readonly loginSession?: LoginSession;
  readonly npmPackageId: Id;
  readonly npmPackage?: NpmPackage;
}

export interface RegistryToken extends Readonly<RegistryTokenData> {}
export class RegistryToken extends BusinessObjectBase {
  static readonly entityName = 'RegistryToken' as const;
  static readonly plural = 'registry-tokens';
  static schema = registryTokenSchema;

  // --- Static CRUD methods ---

  static async find(_filter?: any): Promise<RegistryToken[]> {
    throw new Error('find is not available on RegistryToken');
  }

  static async findOne(_filter?: any): Promise<RegistryToken | null> {
    throw new Error('findOne is not available on RegistryToken');
  }

  static async findById(_id: Id, _filter?: any): Promise<RegistryToken> {
    throw new Error('findById is not available on RegistryToken');
  }

  static async create(_data: any): Promise<RegistryToken> {
    throw new Error('create is not available on RegistryToken');
  }

  static async createMany(_data: any[]): Promise<RegistryToken[]> {
    throw new Error('createMany is not available on RegistryToken');
  }

  static async createWithChildren(_data: any): Promise<RegistryToken> {
    throw new Error('createWithChildren is not available on RegistryToken');
  }

  static async createManyWithChildren(_data: any[]): Promise<RegistryToken[]> {
    throw new Error('createManyWithChildren is not available on RegistryToken');
  }

  static async updateById(_id: Id, _updates: any): Promise<RegistryToken> {
    throw new Error('updateById is not available on RegistryToken');
  }

  static async deleteById(_id: Id): Promise<boolean> {
    throw new Error('deleteById is not available on RegistryToken');
  }
}
